var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-list",class:( _obj = {'align-left': _vm.align === 'left', 'align-right': _vm.align === 'right', 'is-caret': _vm.caret, 'is-levels': _vm.levels}, _obj[_vm.themeClass] = _vm.theme, _obj['is-expanded'] =  _vm.expanded, _obj )},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }